import axios from 'axios'

export default {
    namespaced: true,
    state: {
        users: [],
        rulesList: [],
        auditor: null,
    },
    getters: {
    },
    mutations: {
        FETCH_USERS(state, users) {
            state.users = users
        },
        ADD_USERS(state, user) {
            state.users.push(user)
        },
        EDIT_USERS(state, user) {
            const index = state.users.findIndex(
                item => item.id === user.id
            )
            if (index !== -1) {
                Object.assign(state.users[index], user)
            }
        },
        DEL_USERS(state, user) {
            const index = state.users.findIndex(
                item => item.id === user.id
            )
            if (index !== -1) {
                state.users.splice(index, 1)
            }
        },
        FETCH_RULES(state, rules) {
            state.rulesList = rules
        },
        FETCH_AUDITOR(state, auditor) {
            state.auditor = auditor
        },
    },
    actions: {
        fetch({commit, dispatch}, filter) {
            commit('TOGGLE_PRELOADER', true, {root: true})
            return new Promise((resolve) => {
                axios.post(
                    '/api/mixins/users/list', filter
                ).then(({data}) => {
                    commit('FETCH_USERS', data.list)
                    commit('FETCH_RULES', data.rules)
                    commit('TOGGLE_PRELOADER', false, {root: true})
                    resolve()
                }).catch((error) => {
                    dispatch('checkUnauthenticated', error, { root: true })
                })
            })
        },
        fetchAuditor({ commit, dispatch }, auditor_id) {
            return new Promise((resolve) => {
                axios.post('/api/mixins/tasks/auditor', { auditor_id })
                    .then(({ data }) => {
                        commit('FETCH_AUDITOR', data.data.name);
                        resolve()
                    }).catch((error) => {
                    dispatch('checkUnauthenticated', error, { root: true });
                });
            });
        },
        add({commit, dispatch}, payload) {
            return axios.post(
                '/api/mixins/users/add',
                payload.data
            ).then(({data}) => {
                const checkUserBelongsToCurrentHotel = payload.data.config.hotels.find(
                    item => item.id === payload.currentHotelId
                )
                if(checkUserBelongsToCurrentHotel) {
                    commit('ADD_USERS', data.data)
                }
            }).catch((error) => {
                dispatch('checkUnauthenticated', error, { root: true })
            })
        },
        edit({commit, dispatch}, editedItem) {
            return axios.put(
                '/api/mixins/users/edit/' + editedItem.id,
                editedItem
            ).then(({data}) => {
                commit('EDIT_USERS', data.data)
            }).catch((error) => {
                dispatch('checkUnauthenticated', error, { root: true })
            })
        },
        editPass({commit, dispatch}, editedItem) {
            return axios.put(
                '/api/mixins/users/pass/' + editedItem.id,
                { pass: editedItem.pass }
            ).catch((error) => {
                dispatch('checkUnauthenticated', error, { root: true })
            })
        },
        delete({commit, dispatch}, itemId) {
            return axios.delete(
                '/api/mixins/users/dell/' + itemId
            ).then(({data}) => {
                commit('DEL_USERS', data.data);
            }).catch((error) => {
                dispatch('checkUnauthenticated', error, { root: true })
            })
        },
    }
}
